/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Add_Group_TitleInputs */



/**
* | output |
* | --- |
* | "Add New Group" |
*
* @param {Team_Manager_Add_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_group_title = /** @type {((inputs?: Team_Manager_Add_Group_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Group_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un nouveau groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Gruppe hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi nuovo gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить новую группу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar nuevo grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加新组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいグループを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया समूह जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar novo grupo")
	return /** @type {LocalizedString} */ ("Add New Group")
});